import { useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { revokeAccessToken } from '../sideEffects/actions/auth.actions';

export interface UseSessionExpiredOptions {
  useModal?: boolean; // If true, shows modal; if false, redirects to page
  redirectPath?: string; // Custom redirect path for page mode
}

export const useSessionExpired = (options: UseSessionExpiredOptions = {}) => {
  const { useModal = true, redirectPath = '/session-expired' } = options;
  const [isSessionExpiredModalOpen, setSessionExpiredModalOpen] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleSessionExpired = useCallback(() => {
    dispatch(revokeAccessToken());

    if (useModal) {
      setSessionExpiredModalOpen(true);
    } else {
      navigate(redirectPath);
    }
  }, [dispatch, useModal, redirectPath, navigate]);

  const handleRedirectToLogin = useCallback(() => {
    setSessionExpiredModalOpen(false);
    navigate('/');
  }, [navigate]);

  const closeModal = useCallback(() => {
    setSessionExpiredModalOpen(false);
  }, []);

  return {
    isSessionExpiredModalOpen,
    handleSessionExpired,
    handleRedirectToLogin,
    closeModal,
  };
};
